import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BehaviorSubject } from 'rxjs';
import { CrudHelper } from '../firebase/helpers/crudHelper';
import { CommonService } from '../shared/component-store/common-service';
import { FormService } from '../shared/components/form/form.service';

export const confirmModalData = {
  title: 'Update password',
  icon: 'key',
  okBtn: {
    title: 'YES, DISCARD',
  },
  cancelBtn: { title: 'NO, GO BACK' },
};
export const confirmForDelete = {
  title: 'Delete Profile',
  icon: 'person',
  okBtn: {
    title: 'YES, DELETE',
  },
  cancelBtn: { title: 'No, DISCARD' },
};

@Injectable({ providedIn: 'root' })
export class ProfileService extends CommonService {
  constructor(
    private fireStore: AngularFirestore,
    private firebaseHelperService: CrudHelper,
    private formService: FormService
  ) {
    super(firebaseHelperService);
  }

  currentFollowingPage = new BehaviorSubject(0);

  getProfileGallery(userId: string) {
    return this.fireStore
      .collection('gallery', ref => ref.where('userId', '==', userId))
      .valueChanges({ idField: 'id' });
  }

  updateGallery(id: string, data) {
    return this.firebaseHelperService.updateItem({
      id,
      data,
      collectionName: 'gallery',
    });
  }

  setFilterData(userId, route, isOwnProfile = false) {
    this.formService.formInitialValues.next({ myContent: isOwnProfile });
    switch (route) {
      case 'offers':
        this.formService.jobsMenuData$.next({
          myContent: isOwnProfile,
          creator: userId,
        });
        break;
      case 'searchers':
        this.formService.servicesMenuData$.next({
          myContent: isOwnProfile,
          creator: userId,
          date: null,
          startDate: null,
          endDate: null,
        });
        break;
      case 'second-hand':
        this.formService.secondHandMenuData$.next({
          myContent: isOwnProfile,
          creator: userId,
          swapOption: null,
        });
        break;
      case 'pods':
        this.formService.podMenuData$.next({
          myContent: isOwnProfile,
          country: null,
          approval: null,
          creator: userId,
        });
        break;
      case 'pools':
        this.formService.poolMenuData$.next({
          country: null,
          dogsAllowed: null,
          finsAllowed: null,
          freeEntry: null,
          myContent: isOwnProfile,
          naturePools: null,
          creator: userId,
        });
        break;
      case 'events':
        this.formService.eventMenuData$.next({
          myContent: isOwnProfile,
          creator: userId,
        });
        break;

      default:
        break;
    }
  }

  resetFilter() {
    this.formService.secondHandMenuData$.next(false);
    this.formService.eventMenuData$.next(false);
    this.formService.servicesMenuData$.next(false);
    this.formService.jobsMenuData$.next(false);
    this.formService.podMenuData$.next(false);
    this.formService.poolMenuData$.next(false);
  }
}

